export default __webpack_public_path__ + "static/media/215-falkland-islands.fbc4869d.svg";